import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import LookAiPopupContext from "./LookAiPopupContext";
import {IS_QKB_UI} from "../../../../config";


const LookAIPopupFeatureGroups = () => {

  const {lookAiPopupContext, lookAiPopupDispatch} = useContext(LookAiPopupContext);
  const {groupObjects} = lookAiPopupContext;

  const onCheckboxClick = (gr) => {
    lookAiPopupDispatch({
      groupObjects: groupObjects.map(groupObject => {
        if (groupObject.partId === gr.partId) {
          groupObject.enabled = !groupObject.enabled;
        }
        return groupObject
      }),
    });
  }

  return (
    <div className="flex flex--column">
      <div className="mt-0 mb-1 flex flex--column flex--top w-full">
        <p className={"m-0 bold" + (IS_QKB_UI ? " color-primary" : "")}>
          <FormattedMessage id="look.ai.panel.generateItems"/>
        </p>
        <p className="m-0 font--12 leading-1 look-ai__panel-text">
          <FormattedMessage id="look.ai.panel.generateItemsText"/>
        </p>
      </div>
      <ul className="m-0 p-0 w-full">
        {groupObjects ? groupObjects.map(groupObject => {
          return (
            <li key={groupObject.featureGroup.partId} className="mb-025">
              <FormControlLabel
                style={{color: "#66778D"}}
                label={groupObject.featureGroup.dbName || groupObject.featureGroup.partName}
                className="m-0"
                control={
                  <Switch
                    checked={groupObjects.some(gr => gr.partId === groupObject.partId && gr.enabled)}
                    className="gm-ios-checkbox"
                    disableRipple
                    onChange={() => onCheckboxClick(groupObject)}
                    color="primary"
                  />
                }
              />
            </li>
          )
        }) : null}
      </ul>
    </div>
  )
};

export default LookAIPopupFeatureGroups
